
export function smooth(func : () => void, pauseTime: number) {
    let lastCallTime = 0

    let timeoutId : NodeJS.Timeout | null = null

    let clear = function () {
        if (timeoutId != null)
            clearTimeout(timeoutId)
        timeoutId = null
    }

    let trigger = function () {
        let now = Date.now();
        let sinceLast = now - lastCallTime;
        let callFunc = () => {
            lastCallTime = now
            clear()
            func()
        }
        if (sinceLast > pauseTime) {
            callFunc()
        } else {
            clear()
            let timeoutTime = pauseTime - sinceLast
            if (timeoutTime <= 0) {
                callFunc()
            } else {
                timeoutId = setTimeout(callFunc, timeoutTime)
            }
        }
    }

    return {
        trigger: trigger,
        clear: clear
    }
}

export function float(nowFunc: () => void, endfunc: () => void, pauseTime: number) {
    let timeoutId: NodeJS.Timeout | null = null

    return function () {
        nowFunc()
        if (timeoutId != null)
            clearTimeout(timeoutId)
        timeoutId = setTimeout(function () {
            timeoutId = null
            endfunc()
        }, pauseTime)
    }
}
